module.exports = __webpack_public_path__ + "dbff965962018fada444e70082ed78bb.jpg";